import { useEffect, useState } from "react";
import axios from "axios";

function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min); //The maximum is exclusive and the minimum is inclusive
}

function Artwork({ count }) {
    const [data, setData] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        // Create an scoped async function in the hook
        async function getArt() {
            setIsLoading(true);
            await axios
                .get(`https://collectionapi.metmuseum.org/public/collection/v1/objects/${getRandomInt(437133, 437433)}`)
                .then((response) => {
                    setData(response.data);
                    console.log(response.data);
                    console.log("got data");
                    setIsLoading(false);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
        // Execute the created function directly
        getArt();
    }, [count]);

    useEffect(() => {
        localStorage.setItem("drinkCount", JSON.stringify(count));
    }, [count]);

    return (
        <div>
            <div className="flex justify-center   sm:mt-5  2xl:mt-20 ">
                <div>
                    {isLoading ? (
                        <div className="flex text-2xl sm:text-4xl visible text-gray-500">Loading...</div>
                    ) : (
                        <div className="flex text-2xl sm:text-4xl invisible text-gray-500">Loading...</div>
                    )}

                    <div className="bg-white border-8 border-black  flex-initial shadow-2xl  mx-5 sm:mx-0">
                        {isError && <div className="text-8xl">Whoops! try again.</div>}

                        <img
                            className="h-80 sm:h-96 w-96 min-w-full  object-contain p-2 sm:max-w-xl sm:max-h-full animate-fade-in"
                            alt="artwork"
                            src={
                                data.primaryImageSmall !== ""
                                    ? data.primaryImageSmall
                                    : "https://images.unsplash.com/photo-1535400122808-ddcfffc1a39a?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTB8fGVtcHR5JTIwZnJhbWV8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60"
                            }
                        />
                    </div>
                    <div className="text-xs text-black font-light mx-5 sm:mx-0 p-2 w-auto h-14   ">
                        <p className="font-normal">{data.title}</p>
                        <p className="">{data.artistDisplayName}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Artwork;
